import React, { useState } from "react";
import toast from "react-hot-toast";
import Backend from "../../../../Backend/Backend";

const backend = await new Backend().init();

const EXCHANGE_LABEL = {
  nse: "NSE", nse_cash: "NSE-EQ", mcx: "MCX", fo: "OPTIONS",
  comex_future: "COMEX", crypto_future: "CRYPTO", forex_future: "FOREX",
  us_stock: "US-STOCK", sgx: "SGX", index: "OTHERS",
};
const EXCHANGE_BADGE = {
  nse: { bg: "#E6F1FB", color: "#0C447C" },
  nse_cash: { bg: "#E1F5EE", color: "#085041" },
  mcx: { bg: "#FAEEDA", color: "#633806" },
  fo: { bg: "#EEEDFE", color: "#3C3489" },
  comex_future: { bg: "#EAF3DE", color: "#27500A" },
  crypto_future: { bg: "#FBEAF0", color: "#72243E" },
  forex_future: { bg: "#E1F5EE", color: "#085041" },
  us_stock: { bg: "#FAECE7", color: "#712B13" },
  sgx: { bg: "#F1EFE8", color: "#444441" },
  index: { bg: "#FCEBEB", color: "#791F1F" },
};

export default function EditQty(props) {
  const item = props.item;
  const [loading, setLoading] = useState(false);

  const [symbolDisplay, setSymbolDisplay] = useState(item.symbol_display || item.symbol_name || "");
  const [expiryDate, setExpiryDate] = useState(item.expiry_date?.slice(0, 10) || "");
  const [minQty, setMinQty] = useState(item.min_qty ?? "");
  const [qtyPerOrder, setQtyPerOrder] = useState(item.qty_per_order ?? "");
  const [totalQty, setTotalQty] = useState(item.total_quantity ?? "");
  const [lotSize, setLotSize] = useState(item.lot_size ?? "");
  const [margin, setMargin] = useState(item.margin ?? "");
  const [closeOnlyDays, setCloseOnlyDays] = useState(item.only_sq_day ?? "");

  const UpdateQty = () => {
    if (!minQty || !qtyPerOrder || !totalQty || !lotSize || !margin) {
      toast.error("All fields are required");
      return;
    }
    setLoading(true);

    const data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      symbol_id: item.id,
      symbol_type: item.type,
      symbol_display: symbolDisplay,
      expiry_date: expiryDate,
      min_qty: minQty,
      qty_per_order: qtyPerOrder,
      total_quantity: totalQty,
      lot_size: lotSize,
      margin: margin,
      only_sq_day: closeOnlyDays,
    }

    backend.edit_symbol_main(data).then((r) => {
      setLoading(false);
      if (r.error === "False") {
        toast.success(r.message);
        props.reload();
        props.close();
      } else {
        toast.error(r.message);
      }
    });
  };

  const badge = EXCHANGE_BADGE[item.type] || { bg: "#F1EFE8", color: "#444441" };

  return (
    <div style={{ width: 440, backgroundColor: "var(--background)", fontFamily: "var(--font-sans)", padding: 0 }}>

      {/* ── Header ── */}
      <div style={{ padding: "14px 18px", borderBottom: "0.5px solid var(--color-border-tertiary)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ ...badge, fontSize: 9, fontWeight: 500, padding: "2px 6px", borderRadius: 3, letterSpacing: ".06em" }}>
            {EXCHANGE_LABEL[item.type] || "-"}
          </span>
          <div>
            <p style={{ fontSize: 13, fontWeight: 500, color: "var(--color-text-primary)", margin: 0, fontFamily: "var(--font-mono)", letterSpacing: ".02em" }}>
              {item.symbol_display || item.symbol_name}
            </p>
            <p style={{ fontSize: 11, color: "var(--color-text-tertiary)", margin: "1px 0 0" }}>
              Edit symbol settings
            </p>
          </div>
        </div>
        <button onClick={props.close} style={{ width: 26, height: 26, borderRadius: 6, border: "0.5px solid var(--color-border-tertiary)", background: "transparent", cursor: "pointer", color: "var(--color-text-tertiary)", fontSize: 14, display: "flex", alignItems: "center", justifyContent: "center" }}>
          ✕
        </button>
      </div>

      {/* ── Body ── */}
      <div style={{ padding: "18px 18px 20px" }}>

        {/* Symbol info */}
        <Section label="Symbol info">
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <Field label="Display name" value={symbolDisplay} onChange={setSymbolDisplay} type="text" />
            <Field label="Expiry date" value={expiryDate} onChange={setExpiryDate} type="date" />
          </div>
        </Section>

        <Divider />

        {/* Quantity */}
        <Section label="Quantity settings">
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, marginBottom: 10 }}>
            <Field label="Min qty" value={minQty} onChange={setMinQty} />
            <Field label="Qty per order" value={qtyPerOrder} onChange={setQtyPerOrder} />
            <Field label="Total qty" value={totalQty} onChange={setTotalQty} />
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <Field label="Lot size" value={lotSize} onChange={setLotSize} />
            <Field label="Margin" value={margin} onChange={setMargin} />
          </div>
        </Section>

        <Divider />

        {/* Close only days */}
        <Section label="Close only">
          <Field
            label="Close only days (days before expiry)"
            value={closeOnlyDays}
            onChange={setCloseOnlyDays}
            type="number"
            placeholder="e.g. 3"
          />
        </Section>

        <Divider />

        {/* Submit */}
        <button
          onClick={loading ? null : UpdateQty}
          style={{
            width: "100%", height: 38,
            background: loading ? "var(--color-background-secondary)" : "#185FA5",
            color: loading ? "var(--color-text-tertiary)" : "#fff",
            border: "none", borderRadius: 8,
            fontSize: 13, fontWeight: 500,
            cursor: loading ? "not-allowed" : "pointer",
            letterSpacing: ".04em", transition: "background .15s",
          }}
        >
          {loading ? "Updating..." : "Update symbol"}
        </button>

      </div>
    </div>
  );
}

/* ── Sub-components ── */

function Section({ label, children }) {
  return (
    <div style={{ marginBottom: 16 }}>
      <p style={{ fontSize: 10, fontWeight: 500, color: "var(--color-text-tertiary)", letterSpacing: ".08em", textTransform: "uppercase", margin: "0 0 10px" }}>
        {label}
      </p>
      {children}
    </div>
  );
}

function Divider() {
  return <div style={{ height: "0.5px", background: "var(--color-border-tertiary)", margin: "0 0 16px" }} />;
}

function Field({ label, value, onChange, type = "number", placeholder = "" }) {
  return (
    <div>
      <label style={{ fontSize: 11, color: "var(--color-text-secondary)", display: "block", marginBottom: 4 }}>
        {label}
      </label>
      <input
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        style={{
          width: "100%", height: 34,
          border: "1px solid var(--hover)",
          borderRadius: 7,
          background: "var(--color-background-secondary)",
          color: "var(--color-text-primary)",
          fontSize: 12, padding: "0 10px",
          fontFamily: type === "number" ? "var(--font-mono)" : "inherit",
          boxSizing: "border-box",
          outline: "none",
        }}
      />
    </div>
  );
}